import { BASE_URL } from '../../../Constant';

export const API_GET_ALL_SEARCH_KEYWORDS: string = `${BASE_URL}/document/search/keywords`;
